/**
 * Connection readiness (P382.3) -- the Day-1 question, "can this
 * deployment actually talk to the systems it claims to?"
 *
 * Read-only and derived server-side; there is no stored readiness
 * column to go stale.
 */
import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { api } from "shared/api/client";
import type { ConnectionReadiness } from "shared/api/types";

const KEY = ["admin-connection-readiness"] as const;

export function useConnectionReadiness(): UseQueryResult<ConnectionReadiness> {
  return useQuery<ConnectionReadiness>({
    queryKey: KEY,
    queryFn: () => api.get<ConnectionReadiness>("/v1/admin/connections/readiness"),
  });
}
